import { createContextFromValue } from '@99designs/design-services-common';

export type EnvironmentConfig = {
    public: {
        environment: string;
        bugsnagApiKey: string;
        bugsnagReleaseStage: string;
        enableTranslationDebug?: boolean;
        watchPort: string;
        graphqlHost: string;
    };
};
export const defaultEnvironmentConfig: EnvironmentConfig = {
    public: {
        // Public environment variables that can be used in client-side code
        // Do not include sensitive information here
        environment: '',
        bugsnagApiKey: '',
        bugsnagReleaseStage: '',
        enableTranslationDebug: false,
        watchPort: '',
        graphqlHost: '',
    },
};

export const { Provider: EnvironmentConfigProvider, useValue: useEnvironment } =
    createContextFromValue('EnvironmentContext', defaultEnvironmentConfig.public);
